// removed by extract-text-webpack-plugin
module.exports = {"bubble":"src-components-Testimonials----quote-module---bubble---2bZpC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Testimonials/quote.module.css
// module id = 516
// module chunks = 35783957827783